export default import.meta.ROLLUP_FILE_URL_0i2YXrlmspxl2a9HbIWQgw;